import { useEffect } from 'react';
import { TextBox } from '@apply/components';
import { isMobileScreen } from '@apply/ui';
import { useBrokerNewReferralStore } from '../../../state/useBrokerNewReferralStore';

interface StateNMLSNumberProps {
    onValidationEvent: (isValid: boolean) => void;
}

export const StateNMLSNumber: React.FC<StateNMLSNumberProps> = ({ onValidationEvent }) => {
    const isMobile = isMobileScreen();
    const label = 'Provide your Arizona License Number';
    const subjectPropertyInState = useBrokerNewReferralStore((s) => s.referral.subjectPropertyInAnyStates);
    const value = useBrokerNewReferralStore((s) => s.referral.stateNMLSNumber ?? s.referral.brokerArizonaLicenseNumber);
    const setValue = useBrokerNewReferralStore((s) => s.set_stateNMLSNumber);

    const validateValue = (val: string): boolean => {
        if (!subjectPropertyInState) return true; // not required → always valid
        return val.length >= 4; // required → must be 4+
    };

    // When the field becomes NOT required, clear it + mark valid
    useEffect(() => {
        if (!subjectPropertyInState) {
            if (value !== undefined) setValue(undefined);
            onValidationEvent(true);
        }
    }, [subjectPropertyInState]);

    // Keep parent validation in sync with value changes
    useEffect(() => {
        if (!subjectPropertyInState) {
            onValidationEvent(true);
        } else {
            onValidationEvent(validateValue(value ?? ''));
        }
    }, [value, subjectPropertyInState]);

    return (
        <div
            style={{
                display: subjectPropertyInState ? 'block' : 'none',
                paddingTop: '1.5rem',
                width: isMobile ? '100%' : '375px',
            }}
        >
            <TextBox
                id='stateNMLSNumberTextBox'
                value={value}
                onChange={(newValue) => setValue(newValue)}
                label={label}
                required={subjectPropertyInState}
                width={isMobile ? '100%' : '375px'}
                validateValue={validateValue}
                onValidationEvent={onValidationEvent}
            />
        </div>
    );
};
